import React from "react";
import PropTypes from "prop-types";
import {
  CustomRadioOption,
  OptionLabel,
  StyledOptionButton,
} from "./LabeledRadioButtonStyles.js";

const LabeledRadioButton = ({
  id,
  handleOptionChange,
  currentSelectedOption,
  label,
  btnSize,
  optionsGroup,
}) => {
  return (
    <CustomRadioOption>
      <input
        type="radio"
        name={optionsGroup}
        value={id}
        onChange={handleOptionChange}
        checked={currentSelectedOption === id}
      />
      <StyledOptionButton btnSize={btnSize} />
      <OptionLabel>{label}</OptionLabel>
    </CustomRadioOption>
  );
};

LabeledRadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  handleOptionChange: PropTypes.func.isRequired,
  currentSelectedOption: PropTypes.string,
  label: PropTypes.string.isRequired,
  btnSize: PropTypes.string,
  optionsGroup: PropTypes.string,
};
LabeledRadioButton.defaultProps = {
  currentSelectedOption: "",
};

export default LabeledRadioButton;
